module.exports = __webpack_public_path__ + "static/media/productos_cacahuate_blanequeado_entero.693113dd.png";